import { useRequiredContext } from "@redotech/react-util/context";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo } from "react";
import { matchPath, useLocation } from "react-router-dom";
import {
  MarketingCloudStatusesContext,
  ORDER_TRACKING_ICON,
  ORDER_TRACKING_ICON_FILLED,
} from "../../../../redo-suite/marketing-cloud";

export const OrderTrackingItems = memo(function OrderTrackingItems() {
  const routes = useRequiredContext(MerchantRoutesContext);
  const { orderTrackingEnabled } = useRequiredContext(
    MarketingCloudStatusesContext,
  );

  const trackingBaseUrl = routes.marketingBaseUrl + "/tracking";
  const location = useLocation();
  const anyChildSelected = !!matchPath(
    `${trackingBaseUrl}/*`,
    location.pathname,
  );

  const viewedAboutTrackingPage = localStorage.getItem(
    "viewed_about_tracking_page",
  );

  return (
    <>
      <RedoSecondaryNavItem
        action={{ type: "link", href: routes.getTrackingSubRoute("about") }}
        FilledIcon={ORDER_TRACKING_ICON_FILLED}
        friendlyName="Tracking"
        hidden={orderTrackingEnabled}
        id="order-tracking-about"
        isNew={!viewedAboutTrackingPage}
        UnfilledIcon={ORDER_TRACKING_ICON}
      />
      <RedoSecondaryNavItem
        action={{ type: "link", href: trackingBaseUrl }}
        anyChildSelected={anyChildSelected}
        FilledIcon={ORDER_TRACKING_ICON_FILLED}
        friendlyName="Tracking"
        hidden={!orderTrackingEnabled}
        id="order-tracking"
        UnfilledIcon={ORDER_TRACKING_ICON}
      >
        <RedoSecondaryNavItem
          action={{ type: "link", href: routes.getTrackingSubRoute("orders") }}
          friendlyName="Orders"
          id="orders"
        />
        {/* comment out until shipments are ready */}
        {/* <RedoSecondaryNavItem
          action={{
            type: "link",
            href: routes.getTrackingSubRoute("shipments"),
          }}
          friendlyName="Shipments"
          id="shipments"
        /> */}
        <RedoSecondaryNavItem
          action={{
            type: "link",
            href: routes.getTrackingSubRoute("tracking-page"),
          }}
          friendlyName="Tracking page"
          id="tracking-page"
        />
      </RedoSecondaryNavItem>
    </>
  );
});
